export interface CategoryItem {
  id: string;
  name: string;
  description: string;
  category: string;
  price: string;
  image: string;
  tags: string[];
}

export const categoryData: Record<string, { title: string; description: string; items: CategoryItem[] }> = {
  japanese: {
    title: "日系风格",
    description: "清新自然、简约优雅的和风美学。日系穿搭注重材质质感与色彩和谐，以叠穿和宽松廓形为特点，营造出温柔舒适的高级感。从森系到原宿风，日系风格百变多元，总有一款适合你。",
    items: [
      {
        id: "jp-1",
        name: "日系棉麻宽松衬衫连衣裙",
        description: "天然棉麻材质，轻盈透气。宽松A字廓形修饰身型，腰间细带可调节松紧，轻松打造慵懒日系风。",
        category: "日系",
        price: "¥398",
        image: "https://readdy.ai/api/search-image?query=Japanese%20linen%20cotton%20loose%20shirt%20dress%20in%20cream%20beige%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20elegant%20editorial&width=500&height=650&seq=jp-item-1&orientation=portrait",
        tags: ["棉麻", "宽松", "连衣裙"],
      },
      {
        id: "jp-2",
        name: "日系复古做旧牛仔宽腿裤",
        description: "高腰设计拉长腿部线条，宽松直筒版型修饰腿型。做旧水洗工艺，复古感十足，百搭不挑人。",
        category: "日系",
        price: "¥358",
        image: "https://readdy.ai/api/search-image?query=Japanese%20vintage%20washed%20wide%20leg%20denim%20jeans%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=jp-item-2&orientation=portrait",
        tags: ["复古", "牛仔", "宽腿裤"],
      },
      {
        id: "jp-3",
        name: "日系针织开衫外套",
        description: "柔软亲肤的精纺羊毛混纺，落肩设计随性慵懒。可作外套也可单穿，日杂出镜率超高的百搭单品。",
        category: "日系",
        price: "¥428",
        image: "https://readdy.ai/api/search-image?query=Japanese%20knit%20cardigan%20in%20warm%20oatmeal%20color%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=jp-item-3&orientation=portrait",
        tags: ["针织", "开衫", "百搭"],
      },
      {
        id: "jp-4",
        name: "日系简约帆布托特包",
        description: "厚实帆布材质搭配真皮手柄，大容量设计满足日常通勤需求。简约设计永不过时，日系女孩人手一只。",
        category: "日系",
        price: "¥268",
        image: "https://readdy.ai/api/search-image?query=Japanese%20simple%20canvas%20tote%20bag%20with%20leather%20handles%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=jp-item-4&orientation=portrait",
        tags: ["帆布", "托特包", "通勤"],
      },
      {
        id: "jp-5",
        name: "日系褶皱半身长裙",
        description: "细腻的风琴褶皱工艺，裙摆飘逸灵动。松紧腰设计穿着舒适，搭配简约上衣即可打造温柔日系造型。",
        category: "日系",
        price: "¥328",
        image: "https://readdy.ai/api/search-image?query=Japanese%20pleated%20midi%20skirt%20in%20warm%20beige%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=jp-item-5&orientation=portrait",
        tags: ["褶皱", "半身裙", "优雅"],
      },
      {
        id: "jp-6",
        name: "日系木质手工耳饰",
        description: "天然木材手工打磨，轻盈无负担。几何造型简约别致，为整体造型增添自然气息的点睛之笔。",
        category: "日系",
        price: "¥128",
        image: "https://readdy.ai/api/search-image?query=Japanese%20wooden%20handmade%20earrings%20minimalist%20design%2C%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=jp-item-6&orientation=portrait",
        tags: ["手工", "木质", "耳饰"],
      },
      {
        id: "jp-7",
        name: "日系格纹围巾披肩",
        description: "经典格纹图案搭配柔软羊毛面料，既可做围巾也可当披肩使用，秋冬造型的温暖加分项。",
        category: "日系",
        price: "¥198",
        image: "https://readdy.ai/api/search-image?query=Japanese%20plaid%20wool%20scarf%20shawl%20in%20warm%20neutral%20tones%2C%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=jp-item-7&orientation=portrait",
        tags: ["格纹", "围巾", "秋冬"],
      },
      {
        id: "jp-8",
        name: "日系厚底帆布鞋",
        description: "经典帆布鞋型搭配4cm厚底设计，隐形增高又舒适好走。米白配色百搭所有日系风格。",
        category: "日系",
        price: "¥298",
        image: "https://readdy.ai/api/search-image?query=Japanese%20platform%20canvas%20sneakers%20in%20cream%20white%2C%20minimalist%20product%20photography%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=jp-item-8&orientation=portrait",
        tags: ["帆布鞋", "厚底", "休闲"],
      },
    ],
  },
  korean: {
    title: "韩系风格",
    description: "时尚前卫、精致都市的潮流典范。韩系穿搭以利落剪裁和高级配色著称，注重整体造型的完整度和细节感。从偶像舞台到街头日常，韩流时尚持续引领亚洲潮流风向。",
    items: [
      {
        id: "kr-1",
        name: "韩系宽松廓形西装外套",
        description: "OVERSIZE版型搭配垂感面料，轻松打造韩剧女主同款造型。垫肩设计优化头肩比，百搭黑灰驼三色可选。",
        category: "韩系",
        price: "¥498",
        image: "https://readdy.ai/api/search-image?query=Korean%20oversized%20blazer%20in%20warm%20oak%20color%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=kr-item-1&orientation=portrait",
        tags: ["西装", "廓形", "百搭"],
      },
      {
        id: "kr-2",
        name: "韩系高腰直筒西裤",
        description: "高腰设计搭配垂坠感面料，修饰腿型一绝。前片压褶细节提升质感，通勤约会皆宜的万能裤装。",
        category: "韩系",
        price: "¥328",
        image: "https://readdy.ai/api/search-image?query=Korean%20high%20waist%20straight%20trousers%20in%20cream%20color%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=kr-item-2&orientation=portrait",
        tags: ["高腰", "西裤", "通勤"],
      },
      {
        id: "kr-3",
        name: "韩系短款针织开衫",
        description: "短款剪裁优化身材比例，精致纽扣增添细节感。柔软针织面料亲肤舒适，搭配高腰下装轻松打造韩系甜酷风。",
        category: "韩系",
        price: "¥288",
        image: "https://readdy.ai/api/search-image?query=Korean%20cropped%20knit%20cardigan%20in%20soft%20cream%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=kr-item-3&orientation=portrait",
        tags: ["短款", "针织", "甜酷"],
      },
      {
        id: "kr-4",
        name: "韩系链条斜挎小方包",
        description: "精致金属链条搭配简约包型，容量刚好装下日常必需品。多色可选，韩系博主人手一只的百搭包款。",
        category: "韩系",
        price: "¥358",
        image: "https://readdy.ai/api/search-image?query=Korean%20chain%20crossbody%20bag%20in%20warm%20beige%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=kr-item-4&orientation=portrait",
        tags: ["斜挎包", "链条", "百搭"],
      },
      {
        id: "kr-5",
        name: "韩系厚底乐福鞋",
        description: "经典乐福鞋型搭配5cm厚底，复古又时髦。漆皮亮面质感出众，搭配袜子穿更显韩系风格。",
        category: "韩系",
        price: "¥398",
        image: "https://readdy.ai/api/search-image?query=Korean%20chunky%20loafers%20in%20warm%20tan%20leather%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=kr-item-5&orientation=portrait",
        tags: ["乐福鞋", "厚底", "复古"],
      },
      {
        id: "kr-6",
        name: "韩系宽松卫衣套装",
        description: "柔软拉绒面料搭配宽松版型，居家外出皆宜。简约纯色设计搭配细节刺绣logo，韩系氛围感十足。",
        category: "韩系",
        price: "¥458",
        image: "https://readdy.ai/api/search-image?query=Korean%20oversized%20hoodie%20set%20in%20warm%20oatmeal%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=kr-item-6&orientation=portrait",
        tags: ["卫衣", "套装", "休闲"],
      },
      {
        id: "kr-7",
        name: "韩系金属框墨镜",
        description: "轻盈金属框架搭配渐变镜片，修饰脸型又防晒。韩剧女主同款设计，提升整体造型的时尚完成度。",
        category: "韩系",
        price: "¥198",
        image: "https://readdy.ai/api/search-image?query=Korean%20metal%20frame%20sunglasses%20elegant%20design%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=kr-item-7&orientation=portrait",
        tags: ["墨镜", "金属框", "防晒"],
      },
      {
        id: "kr-8",
        name: "韩系珍珠发夹套装",
        description: "精致仿珍珠搭配金色底座，一套多只用处多多。可单戴也可叠戴，韩系发型点睛之笔的必备小物。",
        category: "韩系",
        price: "¥88",
        image: "https://readdy.ai/api/search-image?query=Korean%20pearl%20hair%20clip%20set%20elegant%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=kr-item-8&orientation=portrait",
        tags: ["发夹", "珍珠", "配饰"],
      },
    ],
  },
  european: {
    title: "欧美风格",
    description: "大气简约、经典质感的国际风尚。欧美穿搭强调剪裁功力和面料品质，以永恒设计对抗快时尚。从法式慵懒到意式精致，欧美风格展现的是自信从容的生活态度。",
    items: [
      {
        id: "eu-1",
        name: "欧美双面羊绒大衣",
        description: "100%纯羊绒双面呢面料，手工缝制工艺。经典廓形永不过时，是值得投资的衣橱传世单品。",
        category: "欧美",
        price: "¥1,998",
        image: "https://readdy.ai/api/search-image?query=European%20double%20face%20cashmere%20coat%20in%20warm%20camel%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=eu-item-1&orientation=portrait",
        tags: ["羊绒", "大衣", "经典"],
      },
      {
        id: "eu-2",
        name: "欧美真丝衬衫",
        description: "100%桑蚕丝面料，珍珠光泽质感出众。经典翻领设计搭配法式袖口，职场与约会皆宜的高级单品。",
        category: "欧美",
        price: "¥598",
        image: "https://readdy.ai/api/search-image?query=European%20silk%20blouse%20in%20cream%20white%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=eu-item-2&orientation=portrait",
        tags: ["真丝", "衬衫", "高级"],
      },
      {
        id: "eu-3",
        name: "欧美极简皮革托特包",
        description: "意大利进口头层牛皮，极简设计搭配精湛工艺。大容量通勤无忧，是陪伴你多年的质感好物。",
        category: "欧美",
        price: "¥1,298",
        image: "https://readdy.ai/api/search-image?query=European%20minimalist%20leather%20tote%20bag%20in%20warm%20tan%2C%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=eu-item-3&orientation=portrait",
        tags: ["皮革", "托特包", "极简"],
      },
      {
        id: "eu-4",
        name: "欧美直筒烟管牛仔裤",
        description: "意大利牛仔面料，弹力适中穿着舒适。经典烟管版型修饰腿型，是打造法式风格的必备单品。",
        category: "欧美",
        price: "¥458",
        image: "https://readdy.ai/api/search-image?query=European%20straight%20cigarette%20jeans%20in%20classic%20denim%20blue%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=eu-item-4&orientation=portrait",
        tags: ["牛仔裤", "直筒", "法式"],
      },
      {
        id: "eu-5",
        name: "欧美羊绒圆领毛衣",
        description: "苏格兰羊绒精纺，轻盈保暖不臃肿。经典圆领设计百搭不挑人，衣橱里的永恒基本款。",
        category: "欧美",
        price: "¥798",
        image: "https://readdy.ai/api/search-image?query=European%20cashmere%20crewneck%20sweater%20in%20warm%20oatmeal%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=eu-item-5&orientation=portrait",
        tags: ["羊绒", "毛衣", "基本款"],
      },
      {
        id: "eu-6",
        name: "欧美切尔西短靴",
        description: "意大利小牛皮鞋面搭配真皮大底，经典切尔西靴型百搭所有裤装。侧边弹力带穿脱方便。",
        category: "欧美",
        price: "¥898",
        image: "https://readdy.ai/api/search-image?query=European%20Chelsea%20boots%20in%20warm%20brown%20leather%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=eu-item-6&orientation=portrait",
        tags: ["短靴", "切尔西", "皮靴"],
      },
      {
        id: "eu-7",
        name: "欧美丝巾发带",
        description: "意大利真丝印花，多用途设计可做发带、包饰或颈巾。艺术感印花提升造型格调。",
        category: "欧美",
        price: "¥258",
        image: "https://readdy.ai/api/search-image?query=European%20silk%20scarf%20hair%20band%20with%20artistic%20print%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=eu-item-7&orientation=portrait",
        tags: ["丝巾", "发带", "配饰"],
      },
      {
        id: "eu-8",
        name: "欧美羊绒围巾",
        description: "苏格兰纯羊绒织造，轻盈柔软却异常保暖。经典纯色设计搭配流苏边，送礼自用两相宜。",
        category: "欧美",
        price: "¥498",
        image: "https://readdy.ai/api/search-image?query=European%20cashmere%20scarf%20in%20warm%20beige%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=eu-item-8&orientation=portrait",
        tags: ["羊绒", "围巾", "保暖"],
      },
    ],
  },
  american: {
    title: "美式风格",
    description: "自由不羁、多元融合的美式风尚。从纽约上东区的精致优雅到洛杉矶的休闲随性，美式风格包罗万象。美式穿搭强调个性表达和舒适自在，让每个人都能找到属于自己的时尚语言。",
    items: [
      {
        id: "us-1",
        name: "美式复古棒球夹克",
        description: "学院风字母刺绣搭配经典棒球夹克版型，内里夹棉保暖不臃肿，美式复古风穿搭的灵魂单品。",
        category: "美式",
        price: "¥528",
        image: "https://readdy.ai/api/search-image?query=American%20varsity%20baseball%20jacket%20in%20cream%20and%20brown%2C%20minimalist%20fashion%20product%20photography%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=us-item-1&orientation=portrait",
        tags: ["棒球夹克", "复古", "学院风"],
      },
      {
        id: "us-2",
        name: "美式高腰牛仔短裤",
        description: "经典美式牛仔水洗工艺，高腰A字版型修饰臀腿。毛边处理更显随性不羁的美式态度。",
        category: "美式",
        price: "¥298",
        image: "https://readdy.ai/api/search-image?query=American%20high%20waist%20denim%20shorts%20classic%20blue%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=us-item-2&orientation=portrait",
        tags: ["牛仔", "短裤", "高腰"],
      },
      {
        id: "us-3",
        name: "美式宽松连帽卫衣",
        description: "重磅加绒面料搭配宽松落肩版型，经典美式休闲风格。胸前简约logo印花，日常穿搭零压力。",
        category: "美式",
        price: "¥358",
        image: "https://readdy.ai/api/search-image?query=American%20oversized%20hoodie%20in%20warm%20heather%20grey%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=us-item-3&orientation=portrait",
        tags: ["卫衣", "连帽", "休闲"],
      },
      {
        id: "us-4",
        name: "美式复古运动鞋",
        description: "80年代复古跑鞋复刻，做旧工艺搭配舒适脚感。经典配色百搭所有休闲风格。",
        category: "美式",
        price: "¥598",
        image: "https://readdy.ai/api/search-image?query=American%20retro%20running%20sneakers%20in%20cream%20and%20tan%2C%20minimalist%20product%20photography%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=us-item-4&orientation=portrait",
        tags: ["运动鞋", "复古", "休闲"],
      },
      {
        id: "us-5",
        name: "美式帆布双肩背包",
        description: "厚实帆布搭配真皮搭扣，复古学院风设计。大容量多隔层，通勤上学旅行的万能背包。",
        category: "美式",
        price: "¥398",
        image: "https://readdy.ai/api/search-image?query=American%20canvas%20backpack%20with%20leather%20straps%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=us-item-5&orientation=portrait",
        tags: ["背包", "帆布", "学院风"],
      },
      {
        id: "us-6",
        name: "美式格子衬衫",
        description: "经典美式法兰绒格纹衬衫，厚实柔软亲肤舒适。可单穿也可当外套叠穿，四季皆宜的实用单品。",
        category: "美式",
        price: "¥258",
        image: "https://readdy.ai/api/search-image?query=American%20flannel%20plaid%20shirt%20in%20warm%20earth%20tones%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=us-item-6&orientation=portrait",
        tags: ["格子衫", "法兰绒", "百搭"],
      },
      {
        id: "us-7",
        name: "美式皮质编织腰带",
        description: "头层牛皮编织工艺，质感出众耐用耐磨。经典美式西部风格设计，搭配牛仔裤一绝。",
        category: "美式",
        price: "¥188",
        image: "https://readdy.ai/api/search-image?query=American%20braided%20leather%20belt%20in%20warm%20brown%2C%20minimalist%20product%20photography%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=us-item-7&orientation=portrait",
        tags: ["腰带", "皮革", "西部风"],
      },
      {
        id: "us-8",
        name: "美式棒球帽",
        description: "经典六片棒球帽版型，后扣可调节大小。简约刺绣logo低调有质感，日常防晒造型两不误。",
        category: "美式",
        price: "¥158",
        image: "https://readdy.ai/api/search-image?query=American%20classic%20baseball%20cap%20in%20cream%20beige%2C%20minimalist%20product%20photography%2C%20clean%20studio%20background%2C%20soft%20natural%20lighting&width=500&height=650&seq=us-item-8&orientation=portrait",
        tags: ["棒球帽", "休闲", "百搭"],
      },
    ],
  },
};

export const categoryTabs = [
  { id: "japanese", name: "日系风格", icon: "ri-sun-line" },
  { id: "korean", name: "韩系风格", icon: "ri-star-line" },
  { id: "european", name: "欧美风格", icon: "ri-vip-crown-line" },
  { id: "american", name: "美式风格", icon: "ri-flag-line" },
];